/* eslint-disable */
require('./folder-simple')
require('./folders')
require('./minus-circle')
require('./minus')
require('./plus-circle')
require('./plus')
